<template>
  <a-drawer :maskClosable="false" width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <div class="checkbox" v-if="role == 2 && !form.id">
      <a-checkbox @change="onChange" v-model="hasSocialCreditCode"> </a-checkbox>
    </div>

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="统一社会信用代码" prop="socialCreditCode"
        v-if="(role == 2 || role == 1) && !isEdit && !hasSocialCreditCode">
        <a-input v-model="form.socialCreditCode" placeholder="请输入" :maxLength="255" @change="handelCode"
          @blur="handelCode" />
      </a-form-model-item>
      <template v-if="(role == 2 || role == 1) && (isCode || hasSocialCreditCode)">
        <a-form-model-item :label="role == 1 ? '企业品牌' : '经销商/公司名称'" prop="name">
          <a-input v-model="form.name" placeholder="请输入" :maxLength="50" :disabled="role == 2 && isCodes ? true : false"
            @change="changeName" />
        </a-form-model-item>
        <a-form-model-item label="招牌名称" prop="referredName">
          <a-input v-model="form.referredName" placeholder="请输入" :maxLength="50"
            :disabled="role == 2 && isCodes ? true : false" />
        </a-form-model-item>
        <a-form-model-item label="编号" prop="code" v-if="role == 1">
          <a-input v-model="form.code" placeholder="请输入(2-4位英文大写)" :maxLength="4"
            :disabled="role == 2 && isCodes ? true : false" />
        </a-form-model-item>
        <a-form-model-item label="联系人" prop="contacts">
          <a-input v-model="form.contacts" placeholder="请输入" :disabled="role == 2 && isCodes ? true : false"
            :maxLength="20" />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="mobile">
          <div @click="handleInputClick" class="input-wrapper">
            <a-input oninput="value=value.replace(/[^\d]/g,'')" v-model="form.mobile" placeholder="请输入" :maxLength="11"
              :disabled="flage && form.id" v-if="infoUser.account == 'admin'" />
            <a-input oninput="value=value.replace(/[^\d]/g,'')" v-model="form.mobile" placeholder="请输入" :maxLength="11"
              :disabled="((role == 2 && isCodes) || form.id) ? true : false" v-else />
            <!-- <a-input v-model="form.phoneNumber" placeholder="请输入" :maxLength="11" :disabled="flage" /> -->
          </div>
        </a-form-model-item>
        <!-- <a-form-model-item label="信用编码" prop="code">
        <a-input v-model="form.code" placeholder="请输入" :maxLength="50" />
      </a-form-model-item> -->
        <template v-if="!isCodes">
          <!-- <a-form-model-item label="统一社会信用代码" prop="socialCreditCode" v-if="role == 1">
            <a-input v-model="form.socialCreditCode" placeholder="请输入" :maxLength="255" />
          </a-form-model-item> -->
          <a-form-model-item label="是否开启代理商审核" prop="openAgentAudit" v-if="role == 1">
            <a-radio-group v-model="form.openAgentAudit" button-style="solid">
              <a-radio-button :value="0"> 关 </a-radio-button>
              <a-radio-button :value="1"> 开 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="营业天" prop="businessDays">
            <a-select mode="multiple" style="width: 100%" placeholder="请选择" @change="handleChange"
              v-model="form.businessDays">
              <a-select-option :value="1">周一</a-select-option>
              <a-select-option :value="2">周二</a-select-option>
              <a-select-option :value="3">周三</a-select-option>
              <a-select-option :value="4">周四</a-select-option>
              <a-select-option :value="5">周五</a-select-option>
              <a-select-option :value="6">周六</a-select-option>
              <a-select-option :value="7">周日</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="营业开始-结束" prop="startTimes">
            <a-time-picker v-model="form.startTimes" :disabled-hours="disabledHour" :disabled-minutes="disabledMinute"
              format="HH:mm" placeholder="选择开始时间" :allowClear="false" @change="handleTime($event, 1)" />
            ~
            <a-time-picker v-model="form.endTimes" :disabled-hours="disabledHours" :disabled-minutes="disabledMinutes"
              format="HH:mm" placeholder="选择结束时间" :allowClear="false" @change="handleTime($event, 2)" />
            <!-- <a-input v-model="form.customerMoblie" placeholder="请输入" :maxLength="255" /> -->
          </a-form-model-item>
          <a-form-model-item label="客服电话" prop="customerMoblie">
            <a-input v-model="form.customerMoblie" placeholder="请输入" :maxLength="15" />
          </a-form-model-item>
          <a-form-model-item label="省市区" prop="area">
            <v-distpicker :province="form.province" :city="form.city" :area="form.area" @province="onChangeProvince"
              @city="onChangeCity" @area="onChangeArea">
            </v-distpicker>
          </a-form-model-item>
          <a-form-model-item label="详细地址" prop="address">
            <a-input v-model="form.address" placeholder="请输入" type="textarea" allow-clear />
          </a-form-model-item>
          <a-form-model-item label="附件图片(营业执照/门牌照等)" prop="fileInfos">
            <file-upload type="image" @input="getImg($event, 'fileInfos')" :file="form.fileInfos" :count="6"
              :isUpload="false" :autoCropHeight="350" :autoCropWidth="350"></file-upload>
            <a-input type="text" v-model="form.fileInfos" v-show="isShow"></a-input>
          </a-form-model-item>

          <a-form-model-item label="质保承诺" prop="commitmentIntroduce" v-if="role == 1">
            <a-input v-model="form.commitmentIntroduce" placeholder="请输入" type="textarea" allow-clear :maxLength="300"
              @change="handleService" />
          </a-form-model-item>
          <a-form-model-item label="分享介绍" prop="serviceIntroduce" v-if="role == 1">
            <a-input v-model="form.serviceIntroduce" placeholder="请输入" type="textarea" allow-clear />
          </a-form-model-item>
          <template>
            <a-form-model-item label="评价" prop="evaluateOptions" v-if="role == 1">
              <a-checkbox-group v-model="form.evaluateOptions" name="checkboxgroup" :options="evaluationOptions" />
            </a-form-model-item>
            <!-- <a-form-model-item label="默认选项" prop="acquiesceModelOptionIds">
              <a-checkbox-group v-model="form.acquiesceModelOptionIds" name="checkboxgroup" :options="ModeLlist" />
            </a-form-model-item> -->
            <!-- <a-form-model-item label="全景图" prop="panoramaImg " v-if="role == 1">
              <file-upload
                type="image"
                :defaultList="form.panoramaImg"
                @input="getImg($event, 'panoramaImg')"
                :file="form.panoramaImg"
                :count="1"
                autoCropHeight="350"
                :isUpload="false"
                autoCropWidth="750"
              ></file-upload>
            </a-form-model-item> -->
            <a-form-model-item label="背景图" prop="backdropImg " v-if="role == 1">
              <file-upload type="image" @input="getImg($event, 'backdropImg')" :file="form.backdropImg" :count="1"
                :isUpload="false" autoCropHeight="1334" autoCropWidth="750"></file-upload>
            </a-form-model-item>
            <a-form-model-item label="公司logo" prop="logoImg">
              <file-upload type="image" @input="getImg($event, 'logoImg')" :file="form.logoImg" :count="1"
                :isUpload="false" autoCropHeight="200" autoCropWidth=""></file-upload>
            </a-form-model-item>
            <a-form-model-item label="公司电子服务章" prop="stampImg" v-if="role == 1">
              <file-upload type="image" :file="form.stampImg" @input="getImg($event, 'stampImg')" :count="1"
                autoCropHeight="200" autoCropWidth="200" :isUpload="false"></file-upload>
            </a-form-model-item>

            <a-form-model-item label="服务电话" prop="serviceMoblie">
              <a-input v-model="form.serviceMoblie" placeholder="请输入" :maxLength="255" />
            </a-form-model-item>
            <a-divider orientation="left" v-if="role == 1">短信通知配置</a-divider>
            <a-form-model-item label="短信-验收通过通知(业主)" prop="smsCheckPassOwner" v-if="role == 1">
              <a-radio-group v-model="form.smsCheckPassOwner" button-style="solid">
                <a-radio-button :value="0"> 关 </a-radio-button>
                <a-radio-button :value="1"> 开 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="短信-验收通过通知(水工)" prop="smsCheckPassPlumber" v-if="role == 1">
              <a-radio-group v-model="form.smsCheckPassPlumber" button-style="solid">
                <a-radio-button :value="0"> 关 </a-radio-button>
                <a-radio-button :value="1"> 开 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="短信-上门验收通知(验收员)" prop="smsCheckVisitChecker" v-if="role == 1">
              <a-radio-group v-model="form.smsCheckVisitChecker" button-style="solid">
                <a-radio-button :value="0"> 关 </a-radio-button>
                <a-radio-button :value="1"> 开 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="短信-上门验收通知(业主)" prop="smsCheckVisitOwner" v-if="role == 1">
              <a-radio-group v-model="form.smsCheckVisitOwner" button-style="solid">
                <a-radio-button :value="0"> 关 </a-radio-button>
                <a-radio-button :value="1"> 开 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </template>
          <a-form-model-item label="备注" prop="remark">
            <a-input v-model="form.remark" placeholder="请输入" type="textarea" allow-clear />
          </a-form-model-item>
        </template>
      </template>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ isCodes ? '绑定' : '保存' }}</a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
    <!-- <a-drawer :maskClosable="false"title="Two-level Drawer" width="320" :closable="false" :visible="childrenDrawer">
      <a-button type="primary"> This is two-level drawer </a-button>
    </a-drawer> -->
    <ReginForm ref="ReginForm" @ok="getQu"></ReginForm>
  </a-drawer>
</template>
<script>
import {
  getTenant,
  addTenant,
  enterpriseBd,
  addEnterprise,
  updateTenant,
  codeTenant,
  tenantBd,
} from '@/api/system/tenant'
import moment from 'moment'
import { regionList, tenantCompany } from '@/api/pressure/region'
import ReginForm from '../../../pressure/region/modules/CreateForm.vue'
import { publicModel } from '@/api/pressure/mode'
import { mapGetters } from 'vuex'
export default {
  name: 'CreateForm',
  props: {
    role: {
      type: Number,
    },
    statusOptions: {
      type: Array,
      required: false,
    },
    userRegion: {
      type: Array,
      required: false,
    },
  },
  components: { ReginForm },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const regs = /^[A-Z]{2,4}$/
    const regCode = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入编号(2-4位英文大写)'))
      } else if (!regs.test(value)) {
        callback(new Error('请输入大写字母2-4位'))
      } else {
        callback()
      }
    }
    const validateSocial = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入统一信用社代码'))
      } else if (!regCode.test(value)) {
        callback(new Error('请输入正确的统一信用社代码'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      formTitle: '',
      childrenDrawer: false,
      showLoading: false,
      // 表单参数
      form: {
        id: undefined,
        address: undefined,
        area: undefined,
        bankCode: undefined,
        bankName: undefined,
        openAgentAudit: 0,
        businessDays: [1, 2, 3, 4, 5, 6, 7],
        city: undefined,
        // code: undefined,
        commitmentIntroduce: undefined,
        contacts: undefined,
        customerMoblie: undefined,
        evaluateOptions: undefined,
        fileInfos: undefined,
        lat: undefined,
        log: undefined,
        logoImg: undefined,
        mobile: undefined,
        name: undefined,
        province: undefined,
        referredName: undefined,
        regionId: undefined,
        remark: undefined,
        serviceIntroduce: undefined,
        serviceMoblie: undefined,
        socialCreditCode: undefined,
        stampImg: undefined,
        startTime: 480,
        endTime: 1080,
        startTimes: moment('2024-10-22 08:00', 'YYYY-MM-DD HH:mm'),
        endTimes: moment('2024-10-22 18:00', 'YYYY-MM-DD HH:mm'),
        smsCheckPassOwner: 0,
        smsCheckPassPlumber: 0,
        smsCheckVisitChecker: 0,
        smsCheckVisitOwner: 0,
      },
      evaluationOptions: [
        { value: 1, label: '商品评价' },
        { value: 2, label: '店家服务态度' },
        { value: 3, label: '安装评价' },
        { value: 4, label: '验收评价' },
        { value: 5, label: '服务评价' },
        { value: 6, label: '回访评价' },
        { value: 7, label: '服务人员形象评价' },
        { value: 8, label: '对服务流程讲解' },
        { value: 9, label: '管路检查及丝堵检查' },
        { value: 10, label: '管道真伪查询' },
        { value: 11, label: '打压试验' },
        { value: 12, label: ' 检查管路漏水、虚焊、漏焊' },
        { value: 13, label: ' 是否张贴关闭总阀及温馨提示' },
        { value: 14, label: '拍摄全景管路图' },
      ],
      open: false,
      isShow: false,
      isCode: false,
      isCodes: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      isEdit: false,
      ModeLlist: [],
      flage: true,
      hasSocialCreditCode: false,
      clickCount: 0, // 点击计数器
      clickTimer: null,
      rules: {
        name: [{ required: true, message: this.role === 1 ? '请输入企业品牌' : '请输入经销商名称', trigger: 'blur' }],
        // referredName: [{ required: true, message: '请输入简称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入信用编码', trigger: 'blur' }],
        stampImg: [{ required: true, message: '请上传公司电子服务章', trigger: 'blur' }],
        socialCreditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { validator: validateSocial, trigger: 'change' },
        ],

        // customerMoblie: [{ required: true, message: '请输入客服电话', trigger: 'blur' }],
        evaluateOptions: [{ required: true, message: '请选择评价', trigger: 'blur' }],
        // fileInfos: [{ required: true, message: '请上传附件图片', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'change' },
        ],
        // code: [
        //   { required: true, message: '请输入编号', trigger: 'blur' },
        //   { validator: validateCode, trigger: 'change' },
        // ],
        commitmentIntroduce: [{ required: true, message: '请输入质保承诺', trigger: 'blur' }],
        regionId: [{ required: true, message: '请选择区域', trigger: 'blur' }],
        address: [{ required: true, message: '请输入详情地址', trigger: 'blur' }],
        area: [{ required: true, message: '请选择地址', trigger: 'blur' }],
        businessDays: [{ required: true, message: '请选择营业天', trigger: 'blur' }],
        contacts: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        serviceIntroduce: [{ required: true, message: '请输入分享介绍', trigger: 'blur' }],
        // serviceMoblie: [{ required: true, message: '请输入服务电话', trigger: 'blur' }],
        logoImg: [{ required: true, message: '请上传公司logo', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    // if (this.role !== 2) {
    //   this.getModel()
    // }
    // console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onChange(e) {
      this.hasSocialCreditCode = e.target.checked
    },

    // 查询所有的产品
    // getModel() {
    //   publicModel().then((response) => {
    //     console.log(response, 'responseresponse')
    //     let arr = []
    //     response.data.records.forEach((v) => {
    //       arr.push({ value: v.id, label: v.productName })
    //     })
    //     this.ModeLlist = arr
    //     console.log(this.ModeLlist, 'this.ModeLlist ')
    //   })
    // },
    changeName(e) {
      this.form.referredName = this.form.name
    },
    handleService(e) {
      if (this.role == 1) {
        console.log(e.target.value, '对对对买买买')
      } else {
        console.log(e.target.value, '对对对买买买4444')
      }
    },
    // 查询区域
    handelCode(e) {
      if (this.form.socialCreditCode) {
        const regs = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
        if (!regs.test(this.form.socialCreditCode)) {
          // this.form = {
          //   socialCreditCode:this.form
          // }
          this.isCode = false
          this.isCodes = false
          return
        }
        console.log(this.form.socialCreditCode, '测试是否走===')
        codeTenant({ code: this.form.socialCreditCode }).then((res) => {
          console.log(res, '的点点滴滴99999')
          if (res.data) {
            this.form = res.data
            this.isCode = true
            this.isCodes = true
          } else {
            this.isCode = false
            this.isCodes = false
            // this.isCode = true
            // this.isCodes = false
            // let socialCreditCode = this.form.socialCreditCode
            // if (e !== 1) {
            //   this.reset()
            // }
            // this.isCode = true
            // this.form.socialCreditCode = socialCreditCode
            tenantCompany({ creditCode: this.form.socialCreditCode }).then((res) => {
              console.log(res, 'resresres测四')
              res = res.data
              this.isCode = true
              this.isCodes = false
              // this.form.referredName = res.companyName
              this.form.name = res.companyName
              this.form.city = res.city
              this.form.area = res.area
              this.form.province = res.province
              this.form.address = res.address
              this.form.lat = res.latitude
              this.form.log = res.longitude
              this.form.contacts = res.faRen
              this.form.remark = res.businessDes
            })
          }
        })
      }
    },
    getQu() {
      regionList().then((res) => {
        console.log(res, '的点点滴滴')
        this.userRegion = res.data
      })
    },
    // 点击添加区域
    handleQu() {
      this.childrenDrawer = true
      this.$nextTick(() => {
        this.$refs.ReginForm.handleAdd()
      })
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() { },
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info5555', info)
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    // 点击选择开始时间和结束时间
    handleTime(e, index) {
      // console.log(e.d,index,'1121212');
      const h = moment(e).format('HH')
      const m = moment(e).format('mm')
      console.log(e, '对对对对对对--===')

      const arr = []
      const array = []
      console.log(h, 'hhhhhh')
      console.log(m, 'hhhhhh')

      if (index === 1) {
        this.form.startTime = Number(h) * 60 + Number(m)
        this.form.startTimes = moment(e).format('YYYY-MM-DD HH:mm')
        console.log(this.form.startTimes, 'this.form.startTimesthis.form.startTimes')

        this.$forceUpdate()
        for (let i = 0; i <= Number(h) - 1; i++) {
          // if (i === 6) {
          //   break // 当 i 等于 5 时，退出循环
          // }
          // console.log('当前值:', i)
          arr.push(i)
        }
        this.hours = arr
        console.log(arr, 'ppppp')
        for (let i = 0; i <= Number(m); i++) {
          array.push(i)
        }
        this.minutes = array
      } else {
        this.form.endTime = Number(h) * 60 + Number(m)
        this.form.endTimes = moment(e).format('YYYY-MM-DD HH:mm')
        this.$forceUpdate()
        for (let i = Number(h) + 1; i <= 24; i++) {
          // if (i === 6) {
          //   break // 当 i 等于 5 时，退出循环
          // }
          // console.log('当前值:', i)
          arr.push(i)
        }
        this.hour = arr
        for (let i = Number(m); i <= 59; i++) {
          array.push(i)
        }
        this.minute = array
        console.log(this.minute, 'minuteminuteminute')
      }

      console.log(h, '12121212')
      console.log(m, '12121212mmm')
    },
    // // 禁用小时
    disabledHours() {
      // 返回需要禁用的小时数组
      return this.hours
    },
    // // 禁用小时
    disabledHour() {
      // 返回需要禁用的小时数组
      return this.hour
    },
    // 选择省
    onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
    onChangeCity(e) {
      if (e.code) {
        this.form.city = e.value
      } else {
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择区
    onChangeArea(e) {
      if (e.code) {
        this.form.area = e.value
      } else {
        this.form.area = ''
      }
    },
    // 禁用分钟
    disabledMinute(selectedHour) {
      if (this.hour && this.hour.length) {
        if (selectedHour === this.hour[0] - 1) {
          return this.minute
        } else {
          return [] // 默认不禁用其他分钟
        }
      } else {
        return [] // 默认不禁用其他分钟
      }
    },
    // 禁用分钟
    disabledMinutes(selectedHour) {
      console.log(selectedHour, 'selectedHour')
      if (this.hours && this.hours.length) {
        const index = this.hours.length - 1
        console.log(this.hours[index], ' this.hours[index]')
        if (selectedHour === this.hours[index] + 1) {
          return this.minutes
        } else {
          return [] // 默认不禁用其他分钟
        }
      } else {
        return [] // 默认不禁用其他分钟
      }
    },
    handleChange(e) {
      console.log(e, '12121212')
      this.form.businessDays = e.sort((a, b) => a - b)
    },
    handleCheng(e) {
      // console.log(e,e.target.value,'点点滴');
      this.form.commitmentIntroduce = e.target.value
    },
    // , 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.flage = true
      this.hasSocialCreditCode = false
      this.form = {
        id: undefined,
        address: undefined,
        area: undefined,
        bankCode: undefined,
        bankName: undefined,
        businessDays: [1, 2, 3, 4, 5, 6, 7],
        city: undefined,
        commitmentIntroduce: undefined,
        contacts: undefined,
        openAgentAudit: 0,
        customerMoblie: undefined,
        evaluateOptions: undefined,
        fileInfos: undefined,
        lat: undefined,
        log: undefined,
        logoImg: undefined,
        mobile: undefined,
        name: undefined,
        province: undefined,
        referredName: undefined,
        regionId: undefined,
        remark: undefined,
        serviceIntroduce: undefined,
        serviceMoblie: undefined,
        socialCreditCode: undefined,
        stampImg: undefined,
        // code: undefined,
        startTime: 489,
        endTime: 1080,
        isAdd: false,
        startTimes: moment('2024-10-22 08:00', 'YYYY-MM-DD HH:mm'),
        endTimes: moment('2024-10-22 18:00', 'YYYY-MM-DD HH:mm'),
        smsCheckPassOwner: 0,
        smsCheckPassPlumber: 0,
        smsCheckVisitChecker: 0,
        smsCheckVisitOwner: 0,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.isCode = false
      this.reset()
      this.open = true
      this.isEdit = false
      this.formTitle = this.role === 1 ? '添加企业品牌' : '添加经销商'
      // console.log(this.role, 'rolerolerole')
      if (this.role == 2) {
        delete this.rules.logoImg
        delete this.rules.logoIserviceMobliemg
        delete this.rules.serviceIntroduce
        // let form = localStorage.getItem('agentForm')
        // if (form) {
        //   form = JSON.parse(form)
        //   this.form = form
        //   console.log(form.socialCreditCode, 'socialCreditCodesocialCreditCode')
        //   if (form.socialCreditCode) {
        //     console.log(form.socialCreditCode, '=======')
        //     this.handelCode(1)
        //   }
        // }
      } else {
      }
    },
    formatSecondsToHMM(seconds) {
      const hours = Math.floor(seconds / 3600) // 计算小时
      const minutes = Math.floor((seconds % 3600) / 60) // 计算分钟

      // 格式化小时和分钟，确保是两位数
      const formattedHours = String(hours).padStart(2, '0')
      const formattedMinutes = String(minutes).padStart(2, '0')

      return `${formattedHours}:${formattedMinutes}`
    },
    handleInputClick() {
      console.log(111)
      // 只有当前处于禁用状态时才计数
      if (this.flage) {
        this.clickCount++
        // 第一次点击时设置定时器，1秒后重置计数
        if (this.clickCount === 1) {
          this.clickTimer = setTimeout(() => {
            this.clickCount = 0 // 1秒后未完成3次点击，重置计数
          }, 1000)
        }
        // 达到3次点击且在1秒内
        else if (this.clickCount >= 3) {
          clearTimeout(this.clickTimer) // 清除定时器
          this.flage = false // 启用输入框
          this.clickCount = 0 // 重置计数
        }
      }
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.isCode = true
      this.isEdit = true
      this.isAdd = false
      this.reset()
      const postId = row ? row.id : ids
      getTenant(postId).then((response) => {
        this.form = response.data
        console.log(response.data, 'response.data')
        const time = moment().startOf('day').unix()
        this.handleTime((time + response.data.startTime * 60) * 1000, 1)
        this.handleTime((time + response.data.endTime * 60) * 1000, 2)
        this.open = true
        this.formTitle = this.role === 1 ? '修改企业品牌' : '修改经销商'
      })
      if (this.role == 2) {
        delete this.rules.logoImg
        delete this.rules.logoIserviceMobliemg
        delete this.rules.serviceIntroduce
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
      console.log(this.isCode, '成都神神叨叨')
      console.log(this.role, 'ddddmmm')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (!this.form.customerMoblie) {
            this.form.customerMoblie = this.form.mobile
            console.log(this.form.customerMoblie, 'this.form.customerMoblie')
          }
          if (!this.form.serviceMoblie) {
            this.form.serviceMoblie = this.form.mobile
          }
          if (!this.form.referredName) {
            this.form.referredName = this.form.name
          }
          this.$forceUpdate()
          if (this.form.id !== undefined) {
            this.form.bankCode = '1'
            this.form.bankName = '1'
            if (this.isCodes) {
              tenantBd(this.form)
                .then((response) => {
                  this.$message.success('绑定成功', 3)
                  this.open = false
                  this.submitLoading = false
                  this.$emit('ok')
                  if (this.role == 1) {
                    localStorage.removeItem('companyForm')
                  } else {
                    localStorage.removeItem('agentForm')
                  }
                })
                .catch(() => {
                  this.submitLoading = false
                  this.showLoading = false
                })
            } else {
              if (!this.form.commitmentIntroduce) {
                this.form.commitmentIntroduce = '保证'
              }
              console.log(this.form.customerMoblie, 'this.form.customerMoblie')

              updateTenant(this.form)
                .then((response) => {
                  this.$message.success('修改成功', 3)
                  if (this.role == 1) {
                    localStorage.removeItem('companyForm')
                  } else {
                    localStorage.removeItem('agentForm')
                  }
                  this.open = false
                  this.$emit('ok')
                  this.submitLoading = false
                })
                .catch(() => {
                  this.submitLoading = false
                  this.showLoading = false
                })
            }
          } else {
            if (this.role === 2) {
              if (this.hasSocialCreditCode) {
                this.form.hasSocialCreditCode = 1
              } else {
                this.form.hasSocialCreditCode = 0
              }
              // 新增经销商
              this.form.commitmentIntroduce = '质保承诺'
              this.form.serviceIntroduce = '服务介绍'
              console.log(this.form.customerMoblie, 'formformform')
              console.log(this.form.serviceMoblie, 'formformform')
              console.log(this.form.customerMoblie, 'formformform')
              addTenant(this.form)
                .then((response) => {
                  this.$message.success('新增成功', 3)
                  this.open = false
                  this.submitLoading = false
                  this.$emit('ok')
                  localStorage.removeItem('agentForm')
                })
                .catch(() => {
                  this.submitLoading = false
                })
            } else {
              // 新增厂商
              addEnterprise(this.form)
                .then((response) => {
                  this.$message.success('新增成功', 3)
                  this.open = false
                  this.submitLoading = false
                  this.$emit('ok')
                  localStorage.removeItem('companyForm')
                })
                .catch(() => {
                  this.submitLoading = false
                })
            }
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.form_select {
  display: flex;
  align-items: center;

  .ant-select {
    width: 300px;
    margin-right: 20px;
  }
}

.input-wrapper {
  display: inline-block;
  position: relative;
  width: 100%;
}

.input-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  /* 确保在输入框上方 */
  pointer-events: auto;
  /* 允许点击穿透到容器 */
}

/* 禁用状态的输入框可能需要调整样式 */
.a-input[disabled] {
  pointer-events: none;
  /* 确保输入框本身不响应点击 */
}

.checkbox {
  position: absolute;
  right: 20px;
  top: 50px;
}
</style>
